import Popup from 'reactjs-popup'
import ReactPlayer from 'react-player'
import {IoMdClose} from 'react-icons/io'

import 'reactjs-popup/dist/index.css'

import './index.css'

const MovieItem = props => {
  const {movie} = props
  return (
    <div className="movie-item-card">
      <Popup
        modal
        nested
        trigger={
          <img
            src={movie.thumbnailUrl}
            alt="thumbnail"
            className="thumbnail-img"
          />
        }
        closeOnDocumentClick
        closeOnEsc
      >
        {close => (
          <div className="popup-card">
            {/* Close Button */}
            <button
              onClick={close}
              type="button"
              className="close-btn"
              data-testid="closeButton"
            >
              <IoMdClose />
            </button>

            <div className="video-player">
              <ReactPlayer
                url={movie.videoUrl}
                width="100%"
                height="100%"
                controls
                playing
                style={{position: 'absolute', top: 0, left: 0}}
                config={{
                  file: {
                    attributes: {
                      controlsList: 'nodownload', // Optional: hides download button
                    },
                  },
                }}
              />
            </div>
          </div>
        )}
      </Popup>
    </div>
  )
}

export default MovieItem
